import { render } from "./TestNotificationItem.vue?vue&type=template&id=518faa0c"
import script from "./TestNotificationItem.vue?vue&type=script&lang=js"
export * from "./TestNotificationItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__